export const definedPermissions = {
  ViewUsers: "ViewUsers",
  AddUser: "AddUser",
  EditUser: "EditUser",
  DeleteUser: "DeleteUser",
  ViewRoles: "ViewRoles",
  AddRole: "AddRole",
  EditRole: "EditRole",
  DeleteRole: "DeleteRole",
  ViewCustomers: "ViewCustomers",
  EditCustomer: "EditCustomer",
  DeleteCustomer: "DeleteCustomer",
  ViewOrders: "ViewOrders",
  ViewCatererDetails: "ViewCatererDetails",
  ViewAirportDropdown: "ViewAirportDropdown",
  ViewIntegrationDashboard: "ViewIntegrationDashboard",
  ViewVendorOrdersDashboard: "ViewVendorOrdersDashboard",
  ViewKitchenPhotos: "ViewKitchenPhotos",
  SwitchCustomerAccount: "SwitchCustomerAccount",
  ViewAdminUsers: "ViewAdminUsers",
  AddAdminUser: "AddAdminUser",
  EditAdminUser: "EditAdminUser",
  DeleteAdminUser: "DeleteAdminUser",
  ActivateAdminUser: "ActivateAdminUser",
  DeactivateAdminUser: "DeactivateAdminUser",
  AcceptRejectVendorOrders: "AcceptRejectVendorOrders",
  MarkVendorOrderDelivered: "MarkVendorOrderDelivered",
  ExportOrderDetails: "ExportOrderDetails",
  CreateCustomer: "CreateCustomer",
  CreateD365Customer: "CreateD365Customer",
  ViewCustomerDetails: "ViewCustomerDetails",
  ViewKitchenOrdersDashboard: "ViewKitchenOrdersDashboard",
  ViewAllKitchenOrders: "ViewAllKitchenOrders",
  Reorder: "Reorder",
  ReviseOrder: "ReviseOrder",
  UpdateOrder: "UpdateOrder",
  UnlockUserAccount: "UnlockUserAccount",
  DeactivateUserAccount: "DeactivateUserAccount",
  ResetPassword: "ResetPassword",
  ViewReporting: "ViewReporting",
  AcceptRejectKitchenOrders: "AcceptRejectKitchenOrders",
  ViewIntegrations: "ViewIntegrations",
  UpdateOrderEmails: "UpdateOrderEmails",
  AddUpdateAnnouncements: "AddUpdateAnnouncements",
  MigrateCustomer: "MigrateCustomer",
  ViewVendorOrders: "ViewVendorOrders",
  ViewAdminReporting: "ViewAdminReporting",
};
